import { Resource } from 'i18next';

import { Translations } from '~/types/appConfig';

export const transformTranslationsToResource = (translations: Map<string, Translations>) =>
  Object.fromEntries(
    Object.entries(translations).map(([key, value]) => [key, { translation: value }]),
  ) as Resource;
